// Simply comment out any components you don't need and they will no longer be auto-injected in to theme.js

// Core
export * from '../../../@infinite/scripts/core/INF-animations';
export * from '../../../@infinite/scripts/core/INF-breakpoints';
export * from '../../../@infinite/scripts/core/INF-debouncedResize';
export * from '../../../@infinite/scripts/core/INF-links';

// Components
export * from '../../../@infinite/scripts/components/INF-IconToggle';
export * from '../../../@infinite/scripts/components/INF-BackgroundVideo';
export * from '../../../@infinite/scripts/components/INF-Modal';
export * from '../../../@infinite/scripts/components/INF-SearchForm';
export * from '../../../@infinite/scripts/components/INF-SiteOverlay';
export * from '../../../@infinite/scripts/components/INF-QuickView';
// export * from '../../../@infinite/scripts/components/INF-RegionRedirect';

// Sections
// INF-SliderCart needs to come first for binding purposes
export * from '../../../@infinite/scripts/sections/INF-SliderCart';
export * from '../../../@infinite/scripts/sections/INF-Header';
export * from '../../../@infinite/scripts/sections/INF-HeroCarousel';
export * from '../../../@infinite/scripts/sections/INF-Pods';
// export * from '../../../@infinite/scripts/sections/INF-Instagram';
export * from '../../../@infinite/scripts/sections/INF-CollectionCarousel';
export * from '../../../@infinite/scripts/sections/INF-CollectionGrid';
export * from '../../../@infinite/scripts/sections/INF-ProductOverview';
export * from '../../../@infinite/scripts/sections/INF-LoginPage';
export * from '../../../@infinite/scripts/sections/INF-MyOrders';
export * from '../../../@infinite/scripts/sections/INF-Blog';
